import {
  Box,
  Grid,
  Heading,
  Text,
  useColorModeValue,
  Stat,
  StatLabel,
  StatNumber,
  Stack,
  HStack,
  Avatar,
  Badge,
  Icon,
  Select,
  IconButton,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
  Input,
  InputGroup,
  InputLeftElement,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import ModalRegistrarMatricula from './ModalRegistrarMatricula';
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import 'react-data-table-component-extensions/dist/index.css';
import {
  FiChevronLeft,
  FiChevronRight,
  FiChevronsLeft,
  FiChevronsRight,
  FiFilter,
  FiList,
} from 'react-icons/fi';
import { customStyles } from '../../helpers/customStyles';
import '../../theme/solarizedTheme';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAllMatriculas,
  getAllMatriculasByGrado,
  getAllMatriculasByTeacher,
  reset,
} from '../../features/matriculaSlice';
import { SiGoogledrive } from 'react-icons/si';
import { AlertEliminar } from './AlertEliminar';
import ReportButton from '../calificaciones/ReporteEstudianteCalificacion';
import { getGradosByDocente, getGradosBySede } from '../../features/gradoSlice';
import { MdRefresh } from 'react-icons/md';
import { getActiveAcademicYear } from '../../features/academicYearSlice';
import ObserverButton from '../calificaciones/ReporteObservacionesEstudiante';
import ModalRegistrarObservaciones from './ModalRegistrarObservaciones';
import { getAllConfiguraciones } from '../../features/configuracionSlice';
import ModalEditarMatricula from './ModalEditarMatricula';
import ReporteFichaMatricula from './ReporteFichaMatricula';
import { Loading } from '../../helpers/Loading';
import ReporteGeneralEstudianteInicialCalificacion from '../calificaciones/ReporteGeneralEstudianteInicialCalificacion';
import ReporteIndividualEstudianteInicialCalificacion from '../calificaciones/ReporteIndividualEstudianteInicialCalificacion';
import ReporteCertificadoEstudiante from './ReporteCertificadoEstudiante';

const Matriculas = () => {
  const dispatch = useDispatch();

  const themeTable = useColorModeValue('default', 'solarized');

  const { sedeSeleccionada, user } = useSelector(state => state.auth);

  const isAdmin = user?.usuario?.rol === 'ADMIN_ROLE' || user?.usuario?.rol === 'COORDINADOR_ROLE';

  const { matriculas, matriculas_teacher, isLoading, currentPage, totalRows, stats } = useSelector(
    state => state.matriculas
  );

  const { configuracion } = useSelector(state => state.configuraciones);

  const { grados, mis_grados } = useSelector(state => state.grados);

  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState('');
  const [selectedGrade, setSelectedGrade] = useState('');

  const calcularTotalEstudiantesPorGrado = gradoId => {
    return matriculas.filter(m => m.grado._id === gradoId && m.estado === 'Activa').length;
  };

  useEffect(() => {
    dispatch(getActiveAcademicYear());
    if (isAdmin) {
      dispatch(getGradosBySede(sedeSeleccionada?._id));
      dispatch(
        getAllMatriculas({
          page: currentPage,
          perPage,
          idSede: sedeSeleccionada?._id,
          search: searchText,
          gradoId: selectedGrade
        })
      );
    }
    dispatch(getAllConfiguraciones());
    if (user?.usuario?.rol === 'DOCENTE_TITULAR_ROLE') {
      dispatch(getGradosByDocente(user?.usuario?.id));
      dispatch(
        getAllMatriculasByTeacher({
          page: currentPage,
          perPage,
          idSede: sedeSeleccionada?._id,
          idDocente: user?.usuario?.id
        })
      );

    }

    return () => {
      dispatch(reset());
    };
  }, [
    dispatch,
    currentPage,
    perPage,
    sedeSeleccionada?._id,
    user?.usuario?.id,
    user?.usuario?.rol,
  ]);

  // Debounced search effect
  useEffect(() => {
    if (!isAdmin) return;

    const timeoutId = setTimeout(() => {
      dispatch(
        getAllMatriculas({
          page: 1,
          perPage,
          idSede: sedeSeleccionada?._id,
          search: searchText,
          gradoId: selectedGrade
        })
      );
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchText, selectedGrade, perPage, sedeSeleccionada?._id, dispatch, isAdmin]);


  const columns = [
    {
      name: 'CODIGO',
      selector: row => row.codigo,
      sortable: true,
      cellExport: row => row.codigo,
      resizable: true,
      width: '120px',
    },
    {
      name: 'ESTUDIANTE',
      selector: row =>
        row.estudiante?.nombres + ' ' + row.estudiante?.apellidos,
      sortable: true,
      cellExport: row =>
        row.estudiante?.apellidos + ' ' + row.estudiante?.nombres,
      resizable: true,
      cell: row => (
        <div>
          <Stack spacing={2} direction="row">
            <Avatar
              size="sm"
              name={row.estudiante?.apellidos + ' ' + row.estudiante?.nombres}
              src={row?.img}
              fontWeight="bold"
              fontSize="sm"
              color="white"
              display={{ base: 'none', sm: 'none', lg: 'flex' }}
            />
            <Text ml={2} noOfLines={2} fontSize="12px" alignSelf={'center'}>
              {row.estudiante?.apellidos + ' ' + row.estudiante?.nombres}
            </Text>
          </Stack>
        </div>
      ),
    },
    {
      name: 'GRADO',
      selector: row => row.grado?.nombre + ' - ' + row.grado?.nivel,
      sortable: true,
      cellExport: row => row.grado?.nombre + ' - ' + row.grado?.nivel,
      resizable: true,
    },
    {
      name: 'ESTADO',
      selector: row => {
        return row.estado;
      },
      sortable: true,
      cellExport: row => row.estado,
      center: true,
      cell: row => (
        <div>
          <Badge
            colorScheme={
              row.estado === 'Activa'
                ? 'green'
                : row.estado === 'Retirado'
                  ? 'blue'
                  : 'red'
            }
            variant="solid"
            w={28}
            textAlign="center"
            py={2}
            rounded="full"
          >
            {row.estado}
          </Badge>
        </div>
      ),
    },
    {
      name: 'ACCIONES',
      export: false,
      center: true,
      cell: row => (
        <div>
          <ModalRegistrarObservaciones
            row={row}
            configuracion={configuracion}
          />
          <ObserverButton
            data={row}
            configuracion={configuracion}
          />
          <ReporteCertificadoEstudiante
            data={row}
            configuracion={configuracion}
          />
          {row.grado?.nivel === 'INICIAL' ? (
            <Popover placement="auto" isLazy size={'sm'}>
              <PopoverTrigger>
                <IconButton
                  aria-label="Options List"
                  icon={<Icon as={FiList} fontSize="xl" />}
                  size="md"
                  mr={2}
                  colorScheme="orange"
                  isRound
                  variant="solid"
                  _dark={{ color: 'white' }}
                />
              </PopoverTrigger>
              <PopoverContent>
                <PopoverArrow />
                <PopoverBody>
                  <Stack spacing={2} direction="row">
                    <ReporteGeneralEstudianteInicialCalificacion
                      data={row}
                      getTotalEstudiantesPorGrado={() =>
                        calcularTotalEstudiantesPorGrado(row.grado._id)
                      }
                      configuracion={configuracion}
                    />
                    <ReporteIndividualEstudianteInicialCalificacion
                      data={row}
                      getTotalEstudiantesPorGrado={() =>
                        calcularTotalEstudiantesPorGrado(row.grado._id)
                      }
                      configuracion={configuracion}
                    />
                  </Stack>
                </PopoverBody>
              </PopoverContent>
            </Popover>
          ) : (
            <ReportButton
              data={row}
              getTotalEstudiantesPorGrado={() =>
                calcularTotalEstudiantesPorGrado(row.grado._id)
              }
              configuracion={configuracion}
            />
          )}
          <ModalEditarMatricula
            data={row}
            configuracion={configuracion}
            grados={grados}
            mis_grados={mis_grados}
          />
          <ReporteFichaMatricula
            data={row}
            configuracion={configuracion}
          />
          <AlertEliminar
            row={row}
            configuracion={configuracion}
          />
        </div>
      ),
      width: '380px',
    },
  ];

  const handlePageChange = page => {
    setPage(page);
    if (isAdmin) {
      dispatch(
        getAllMatriculas({
          page,
          perPage,
          idSede: sedeSeleccionada?._id,
          search: searchText,
          gradoId: selectedGrade
        })
      );
    }
  };

  const handleRowsPerPageChange = newPerPage => {
    setPerPage(newPerPage);
    if (isAdmin) {
      dispatch(
        getAllMatriculas({
          page: 1,
          perPage: newPerPage,
          idSede: sedeSeleccionada?._id,
          search: searchText,
          gradoId: selectedGrade
        })
      );
    }
  };

  const handleChangeGrado = e => {
    setSelectedGrade(e.target.value);
    setPage(1);
  };

  const handleUpdateMatricula = () => {
    if (isAdmin) {
      dispatch(
        getAllMatriculas({
          page: 1,
          perPage,
          idSede: sedeSeleccionada?._id,
          search: searchText,
          gradoId: selectedGrade
        })
      );
    }
  };

  const tableData = {
    columns: columns,
    data: isAdmin ? matriculas : matriculas_teacher,
  };

  // if (isLoading) {
  //   return <Loading />;
  // }

  return (
    <Box>
      <Grid
        templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }}
        gap={6}
        mb={4}
      >
        <StatCard
          title="Total Matrículas"
          value={
            isAdmin
              ? stats?.total || matriculas.length || '0'
              : matriculas_teacher.length || '0'
          }
          colorScheme="blue"
        />
        <StatCard
          title="Activas"
          value={
            isAdmin
              ? stats?.active || matriculas?.filter(m => m.estado === 'Activa')?.length || '0'
              : matriculas_teacher?.filter(m => m.estado === 'Activa')?.length ||
              '0'
          }
          colorScheme="green"
        />
        <StatCard
          title="Finalizadas"
          value={
            isAdmin
              ? stats?.finished || matriculas?.filter(m => m.estado === 'Finalizada')?.length ||
              '0'
              : matriculas_teacher?.filter(m => m.estado === 'Finalizada')
                ?.length || '0'
          }
          colorScheme="red"
        />
      </Grid>
      <Stack spacing={4} direction="row" justifyContent="space-between">
        <HStack
          spacing={4}
          direction="row"
          w={'full'}
          justifyContent={'space-between'}
        >
          <Heading size="md">LISTA DE ESTUDIANTES MATRICULADOS</Heading>
          <ModalRegistrarMatricula
            configuracion={configuracion}
            grados={grados}
            mis_grados={mis_grados}
          />
        </HStack>
      </Stack>
      <Stack
        mt={4}
        spacing={4}
        display={isAdmin ? 'flex' : 'none'} // Use flex instead of block for Stack
        direction={{ base: 'column', lg: 'row' }}
        justifyContent="space-between"
        alignItems={{ base: 'start', lg: 'center' }}
      >
        <Box w={{ base: 'full', lg: '600px' }}>
          <InputGroup>
            <InputLeftElement pointerEvents="none">
              <Icon as={FiFilter} color="gray.400" />
            </InputLeftElement>
            <Input
              type="text"
              placeholder="Buscar estudiante... (Nombre, Apellido, DNI, Código)"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              borderRadius="full"
              bg={useColorModeValue('white', 'gray.700')}
            />
          </InputGroup>
        </Box>

        <HStack spacing={4} w={{ base: 'full', lg: 'auto' }} justifyContent="flex-end">
          <Heading size="sm" whiteSpace="nowrap">Filtrar por Grados</Heading>
          <Stack direction="row" spacing={4}>
            <Select
              onChange={handleChangeGrado}
              icon={<Icon as={FiFilter} fontSize="xl" />}
              value={selectedGrade}
              colorScheme="primary"
              placeholder="Selecciona un grado"
            >
              {grados?.map(data => (
                <option key={data._id} value={data._id}>
                  {data.nombre} - {data.nivel}
                </option>
              ))}
            </Select>

            <IconButton
              aria-label="Actualizar"
              onClick={handleUpdateMatricula}
              icon={<Icon as={MdRefresh} fontSize="2xl" />}
              fontSize="2xl"
              colorScheme="primary"
              _dark={{ color: 'white', _hover: { bg: 'primary.300' } }}
              variant={'solid'}
            />
          </Stack>
        </HStack>
      </Stack>
      <Box
        borderRadius="2xl"
        borderTop={'2px'}
        borderTopColor={'primary.100'}
        overflow="hidden"
        boxShadow={'base'}
        bg="white"
        _dark={{ bg: 'primary.1000' }}
        mt={2}
        pt={2}
      >
        <DataTableExtensions
          {...tableData}
          print={false}
          exportHeaders={true}
          filter={false} // Disable client-side filter to use server-side search input
          numberOfColumns={columns.length}
          fileName={'ESTUDIANTES' + new Date().toLocaleDateString()}
        >
          <DataTable
            defaultSortField="nombre"
            progressPending={isLoading}
            progressComponent={<Loading />}
            defaultSortAsc={false}
            defaultSortOrder="asc"
            pagination
            paginationIconFirstPage={
              <Icon
                as={FiChevronsLeft}
                boxSize={6}
                _dark={{ color: 'gray.300' }}
              />
            }
            paginationIconLastPage={
              <Icon
                as={FiChevronsRight}
                boxSize={6}
                _dark={{ color: 'gray.300' }}
              />
            }
            paginationIconPrevious={
              <Icon
                as={FiChevronLeft}
                boxSize={6}
                _dark={{ color: 'gray.300', _hover: { color: 'white' } }}
              />
            }
            paginationIconNext={
              <Icon
                as={FiChevronRight}
                boxSize={6}
                _dark={{ color: 'gray.300', _hover: { color: 'white' } }}
              />
            }
            paginationServer
            paginationPerPage={isAdmin ? perPage : 10}
            onChangeRowsPerPage={handleRowsPerPageChange}
            paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30, 50]}
            paginationDefaultPage={page}
            paginationTotalRows={totalRows}
            onChangePage={handlePageChange}
            paginationComponentOptions={{
              rowsPerPageText: 'Filas por pagina:',
              rangeSeparatorText: 'de',
              noRowsPerPage: false,
              selectAllRowsItem: true,
              selectAllRowsItemText: 'Todos',
            }}
            theme={themeTable}
            customStyles={customStyles}
            pointerOnHover={true}
            responsive={true}
            noDataComponent={
              <Text mb={4} fontSize="lg">
                NO HAY REGISTROS
              </Text>
            }
          />
        </DataTableExtensions>
      </Box>
    </Box>
  );
};

export default Matriculas;

const StatCard = ({ title, value, colorScheme }) => (
  <Box
    _dark={{ bg: 'primary.1000' }}
    p={4}
    borderRadius="2xl"
    boxShadow="md"
    borderWidth="1px"
  >
    <Stat>
      <StatLabel color="gray.500" mb={1}>
        {title}
      </StatLabel>
      <StatNumber fontSize="3xl" color={`${colorScheme}.600`}>
        {value}
      </StatNumber>
    </Stat>
  </Box>
);
